@if(value != '' || showOnEmpty){
<div class="caseContainer {{ elementStyle }}">
  <label class="caseLabelStyle {{ labelStyle }}"
    >
     @if (labelTpl) {
        <ng-container
          *ngTemplateOutlet="
            labelTpl;
            context: {
              $implicit: value,
              label: label
            }
          "
        >
        </ng-container>
      } @else {
        {{ labelText }}
      }
    
   
    @if(helptext){
    <span
      class="fa fa-question-circle tooltipIconStyle"
      [libtooltip]="helptext"
    ></span>
    } @if(seperator){
    <span>:&nbsp; </span>
    }
  </label>

  <div class="caseValueStyle {{ valueStyle }}">
    @if(!type && !refm && !options){
    {{ value | defaultValue }}
    } @else{ @if(refm){
    <span class="notranslate">
      @if(multiple){
      {{ value | optionpipe : getRefmOptions() }}
      } @else{
      {{ value | refmLangPipe : refm : getLanguage() }}
      }
    </span>
    } @else if(options){
    <!-- option -->
    {{ value | optionpipe : options }}
    } @else{ @switch(type){ @case (2){
    <!-- currency  -->
    @if( value != ''){
    {{ value | defaultValue | currency : "USD" : "symbol" : "1.2-2" }}
    } } @case (3){
    <!-- dateTime = 3, -->
    {{ value | validDateTime | date : "MM/dd/yyyy hh:mm a" }}
    } @case (5){
    <!-- refm -->
    {{ value | defaultValue | refmpipe : refm }}
    } @case (6){
    <!-- date -->
    {{ value | dateAlone | date : "MM/dd/yyyy" }}
    } @case (9){
    <!-- phone -->
    {{ value | defaultValue | phone }}
    } @case (13){
    <!-- zip -->
    {{ value | defaultValue | zip }}
    } @case (20){
    <!-- tooltip element -->
    @if(valueToolTip) { <span [libtooltip]="valueToolTip">{{ value }} </span>}
    }
    @case (12){
    <!-- ssn -->
    @if(isAdmin){ @if(formatSsn){
    {{ value | defaultValue | ssn }}
    }@else{
    {{ value | defaultValue }}
    <!-- for admin pdf- no need to format ssn -->
    } } @else{
    {{ value | defaultValue | ssn }}
    } } } } }
  </div>
</div>
}
